export const ru = ({
  attach_permission_tag_group: {
    empty: 'Нет доступных групп',
    load_error: 'Не удалось загрузить группы',
    on_error: 'Не удалось добавить группу',
    on_success: 'Группа добавлена',
    title: 'Добавить',
  },
}) as Record<string, unknown>;

export const en = ({
  attach_permission_tag_group: {
    empty: 'No groups available',
    load_error: 'Failed to load groups',
    on_error: 'Failed to attach group',
    on_success: 'Group attached',
    title: 'Add',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  attach_permission_tag_group: {
    empty: 'Nenhum grupo disponível',
    load_error: 'Não foi possível carregar os grupos',
    on_error: 'Não foi possível adicionar o grupo',
    on_success: 'Grupo adicionado',
    title: 'Adicionar',
  },
}) as Record<string, unknown>;

export const esEs = ({
  attach_permission_tag_group: {
    empty: 'No hay grupos disponibles',
    load_error: 'No se pudieron cargar los grupos',
    on_error: 'No se pudo agregar el grupo',
    on_success: 'Grupo agregado',
    title: 'Agregar',
  },
}) as Record<string, unknown>;
